import { render } from "./jmadd.vue?vue&type=template&id=72045dab&scoped=true"
import script from "./jmadd.vue?vue&type=script&lang=js"
export * from "./jmadd.vue?vue&type=script&lang=js"

import "./jmadd.vue?vue&type=style&index=0&id=72045dab&lang=scss&scoped=true"
import "./jmadd.vue?vue&type=style&index=1&id=72045dab&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72045dab"]])

export default __exports__